import { GET_PINS } from '../../constants/ActionTypes';

export function getPins() {
  const path = '/@pins';

  return {
    type: GET_PINS,
    request: {
      op: 'get',
      path: path,
    },
  };
}
